import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  @Input() products;
  search_term;
  active = false;


  constructor(public shared: Shared) { }

  ngOnInit() {
  }

  toggleActive(){
      this.active = !this.active;
      this.active ? document.getElementById('new_product').style.maxHeight = '2000px' : document.getElementById('new_product').style.maxHeight = '0px';
  }

  scrollToTop(){
      return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/products/products.component.ts